import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";


import banner from '../assets/pictures/topbanner.jpg';

export default function Header() {
  const [pageState, setPageState] = useState("Sign in");
  const location = useLocation();
  const navigate = useNavigate();
  const auth = getAuth();
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setPageState("Profile");
      } else {
        setPageState("Sign in");
      }
    });
  }, [auth]);
  function pathMatchRoute(route) {
    if (route === location.pathname) {
      return true;
    }
  }
  return (
    <div className="bg-white border-b shadow-sm sticky top-0 z-40">
      <header className="flex justify-between items-center px-3 max-w-6xl mx-auto">
        <div>
        

{/*
<blockquote class="text-x12 italic font-semibold text-gray-900 dark:text-white">
    <p>Castle Point</p>
</blockquote>
*/}


{/*

          <img
          src={banner} 
           width="80" 
          height="25"
           
            alt="banner"
            className="h-10 cursor-pointer"
            onClick={() => navigate("/")}
          />
          */}
          
        </div>
        <div>
          <ul className="flex space-x-10">
            <li
              className={`cursor-pointer py-3 text-sm font-semibold text-gray-400 border-b-[3px] border-b-transparent ${
                pathMatchRoute("/") && "text-black border-b-red-500"
              }`}
              onClick={() => navigate("/")}
            >
              {' '}Home
            </li>
            <li
              className={`cursor-pointer py-3 text-sm font-semibold text-gray-400 border-b-[3px] border-b-transparent ${
                pathMatchRoute("/tourers") && "text-black border-b-red-500"
              }`}
              onClick={() => navigate("/tourers")}
            >
              Touring & Camping
            </li>

            <li
              className={`cursor-pointer py-3 text-sm font-semibold text-gray-400 border-b-[3px] border-b-transparent ${
                pathMatchRoute("/statics") && "text-black border-b-red-500"
              }`}
              onClick={() => navigate("/statics")}
            >
             Caravan Hire
            </li>

            <li
              className={`cursor-pointer py-3 text-sm font-semibold text-gray-400 border-b-[3px] border-b-transparent ${
                pathMatchRoute("/localactivities") && "text-black border-b-red-500"
              }`}
              onClick={() => navigate("/localactivities")}
            >
             Activities 
            </li>


            <li
              className={`cursor-pointer py-3 text-sm font-semibold text-gray-400 border-b-[3px] border-b-transparent ${
                pathMatchRoute("/caravansforsale") && "text-black border-b-red-500"
              }`}
              onClick={() => navigate("/caravansforsale")}
            >
              For Sale
            </li>


{/* 
            <li
              className={`cursor-pointer py-3 text-sm font-semibold text-gray-400 border-b-[3px] border-b-transparent ${
                (pathMatchRoute("/sign-in") || pathMatchRoute("/profile")) &&
                "text-black border-b-red-500"
              }`}
              onClick={() => navigate("/profile")}
            >
              {pageState}
            </li>
            */} 
          </ul>
        </div>
      </header>
    </div>
  );
}
